import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../helpers/common/ArrowIcons';
import cs from '../../../components/commonStyle.css';

const ImageDisplayModal = ({
  show,
  onHide,
  images = [],
  currentIndex = 0,
  onPrev,
  onNext
}) => {
  const currentImage = images && images.length > 0 ? images[currentIndex] : null;
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {currentImage?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        {currentImage && (
          <>
            <img
              src={currentImage.url}
              alt={currentImage.title}
              style={{ maxWidth: '100%', maxHeight: '60vh', borderRadius: 8 }}
            />
            <div style={{ marginTop: 18, fontSize: 16, color: '#444', wordBreak: 'break-word' }}>
              <strong>Remark:</strong> {currentImage.remark || '-'}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'space-between' }}>
        {images && images.length > 1 && (
          <>
            <button
              className={cs.btnPrimary}
              style={{
                fontSize: 22,
                padding: '6px 18px',
                background: currentIndex === 0 ? '#f5f5f5' : undefined,
                cursor: currentIndex === 0 ? 'not-allowed' : undefined,
                border: currentIndex === 0 ? '1px solid #e0e0e0' : undefined
              }}
              onClick={onPrev}
              disabled={currentIndex === 0}
              aria-label="Previous"
            >
              <ArrowLeftIcon style={{ fill: '#fff', opacity: currentIndex === 0 ? 0.5 : 1 }} />
            </button>
            <button
              className={cs.btnPrimary}
              style={{
                fontSize: 22,
                padding: '6px 18px',
                background: currentIndex === images.length - 1 ? '#f5f5f5' : undefined,
                cursor: currentIndex === images.length - 1 ? 'not-allowed' : undefined,
                border: currentIndex === images.length - 1 ? '1px solid #e0e0e0' : undefined
              }}
              onClick={onNext}
              disabled={currentIndex === images.length - 1}
              aria-label="Next"
            >
              <ArrowRightIcon style={{ fill: '#fff', opacity: currentIndex === images.length - 1 ? 0.5 : 1 }} />
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

ImageDisplayModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  images: PropTypes.array,
  currentIndex: PropTypes.number,
  onPrev: PropTypes.func,
  onNext: PropTypes.func
};

export default ImageDisplayModal;
